// Promise - https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Promise
require('es6-promise').polyfill();

// fetch - https://developer.mozilla.org/en/docs/Web/API/Fetch_API
require('whatwg-fetch');